import apiRequest from "./apiClient";

// --- Advertisements ---
export async function fetchAdvertisements() {
  const body = await apiRequest("/api/v1/admin/promotions/advertisements");
  return body.data;
}

export async function createAdvertisement(payload) {
  const body = await apiRequest("/api/v1/admin/promotions/advertisements", {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return body.data;
}

export async function updateAdvertisement(id, payload) {
  const body = await apiRequest(`/api/v1/admin/promotions/advertisements/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
  return body.data;
}

export async function deleteAdvertisement(id) {
  await apiRequest(`/api/v1/admin/promotions/advertisements/${id}`, { method: "DELETE" });
}

// --- Lucky draws ---
export async function fetchLuckyDraws() {
  const body = await apiRequest("/api/v1/admin/promotions/lucky-draws");
  return body.data;
}

export async function fetchLuckyDraw(id) {
  const body = await apiRequest(`/api/v1/admin/promotions/lucky-draws/${id}`);
  return body.data;
}

export async function createLuckyDraw(payload) {
  const body = await apiRequest("/api/v1/admin/promotions/lucky-draws", {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return body.data;
}

export async function updateLuckyDraw(id, payload) {
  const body = await apiRequest(`/api/v1/admin/promotions/lucky-draws/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
  return body.data;
}

export async function deleteLuckyDraw(id) {
  await apiRequest(`/api/v1/admin/promotions/lucky-draws/${id}`, { method: "DELETE" });
}

export async function addLuckyDrawOption(campaignId, payload) {
  const body = await apiRequest(`/api/v1/admin/promotions/lucky-draws/${campaignId}/options`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return body.data;
}

export async function updateLuckyDrawOption(optionId, payload) {
  const body = await apiRequest(`/api/v1/admin/promotions/lucky-draws/options/${optionId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
  return body.data;
}

export async function deleteLuckyDrawOption(optionId) {
  await apiRequest(`/api/v1/admin/promotions/lucky-draws/options/${optionId}`, { method: "DELETE" });
}

// --- Coupons ---
export async function fetchPromoCoupons() {
  const body = await apiRequest("/api/v1/admin/promotions/coupons");
  return body.data;
}

export async function markCouponUsed(couponId, note = "") {
  const params = note ? `?note=${encodeURIComponent(note)}` : "";
  const body = await apiRequest(`/api/v1/admin/promotions/coupons/${couponId}/mark-used${params}`, {
    method: "POST",
  });
  return body.data;
}

export async function redeemCoupon({ userId, couponCode, adminNote }) {
  const body = await apiRequest("/api/v1/admin/promotions/coupons/redeem", {
    method: "POST",
    body: JSON.stringify({ userId, couponCode, adminNote }),
  });
  return body.data;
}
